import moment from "moment-timezone";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

import {
  CREATE_SUBTASK,
  CREATE_SUBTASK_FAILURE,
  CREATE_SUBTASK_SUCCESS,
  DELETE_JOB,
  DELETE_JOB_FAILURE,
  DELETE_JOB_SUCCESS,
  DELETE_SUBTASK,
  DELETE_SUBTASK_FAILURE,
  DELETE_SUBTASK_SUCCESS,
  EXPORT_JOB_REPORT,
  EXPORT_JOB_REPORT_FAILURE,
  EXPORT_JOB_REPORT_SUCCESS,
  GET_JOBS_LIST,
  GET_JOBS_LIST_FAILURE,
  GET_JOBS_LIST_SUCCESS,
  GET_JOBS_SHORT_LIST,
  GET_JOBS_SHORT_LIST_FAILURE,
  GET_JOBS_SHORT_LIST_SUCCESS,
  GET_JOB_DETAILS,
  GET_JOB_DETAILS_FAILURE,
  GET_JOB_DETAILS_SUCCESS,
  GET_SUBTASKS,
  GET_SUBTASKS_FAILURE,
  GET_SUBTASKS_SUCCESS,
  JOB_ASSIGNEE_ADD,
  JOB_ASSIGNEE_ADD_FAILURE,
  JOB_ASSIGNEE_ADD_SUCCESS,
  JOB_ASSIGNEE_REMOVE,
  JOB_ASSIGNEE_REMOVE_FAILURE,
  JOB_ASSIGNEE_REMOVE_SUCCESS,
  RESET_SUBTASK_STATUS,
  UPDATE_JOB_STATUS,
  UPDATE_JOB_STATUS_FAILURE,
  UPDATE_JOB_STATUS_SUCCESS,
  UPDATE_SUBTASK,
  UPDATE_SUBTASK_FAILURE,
  UPDATE_SUBTASK_SUCCESS,
  GET_JOB_DOCUMENTS_LIST,
  GET_JOB_DOCUMENTS_LIST_SUCCESS,
  GET_JOB_DOCUMENTS_LIST_FAILURE,
  CREATE_JOB_DOCUMENT_SUCCESS,
  CREATE_JOB_DOCUMENT_FAILURE,
  DELETE_JOB_DOCUMENT_SUCCESS,
  DELETE_JOB_DOCUMENT_FAILURE,
  DELETE_JOB_DOCUMENT,
  CREATE_JOB_DOCUMENT,
} from "../../modules/constants";
import { Message, createNotification } from "../../modules/notificationManager";

export const jobListRequestHandler = (state, action) => {
  return {
    ...state,
    isLoadingJobs: true,
  };
};
export const jobListRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    const list = JSON.parse(JSON.stringify(data.data.results));
    list.forEach(item => {
      const assigneesData = [...item.assignees];

      assigneesData.forEach((assignee, index) => {
        const checkedin = item.checkinout.find(
          obj => obj.event === "checkin" && obj.user === assignee.id,
        );
        const checkedout = item.checkinout.find(
          obj => obj.event === "checkout" && obj.user === assignee.id,
        );
        const evidencesForAssignee = (item.evidences || []).filter(
          obj => obj.created_by === assignee.id,
        );

        if (checkedin) {
          assigneesData[index].checkedin = checkedin;
        }
        if (checkedout) {
          assigneesData[index].checkedout = checkedout;
        }
        /* 
        +------------+-------------+---------------+-----------------+-------------+
        | Checked In | Checked Out | Job End Time  | Assignee Status | Results     |
        +------------+-------------+---------------+-----------------+-------------+
        | True       |             |               | False           | In Progress |
        +------------+-------------+---------------+-----------------+-------------+
        | True       | True        |               | True            | Completed   |
        +------------+-------------+---------------+-----------------+-------------+
        | False      | False       | In Range      | False           | To Do       |
        +------------+-------------+---------------+-----------------+-------------+
        | False      | False       | crossed       | false           | Missed      |
        +------------+-------------+---------------+-----------------+-------------+
  */
        if (assignee.assignee_status) {
          if (checkedin && checkedout) {
            assigneesData[index].status = "Completed";
          }
        } else {
          if (checkedin) {
            if (!checkedout) {
              assigneesData[index].status = "In Progress";
            }
          } else {
            if (
              !checkedout &&
              moment().unix() < moment(item.required_end_date).unix()
            ) {
              assigneesData[index].status = "To Do";
            } else {
              assigneesData[index].status = "Missed";
            }
          }
        }

        if (evidencesForAssignee && evidencesForAssignee.length) {
          assigneesData[index].evidences = evidencesForAssignee;
          // keep first evidence for backward compatibility
          assigneesData[index].evidence = evidencesForAssignee[0];
        }
      });
    });

    //just test purpose will remove it later
    // const employeeNoteText = 'Some text';
    // list.forEach(item => {
    //   item.employee_note = employeeNoteText;
    // });
    return {
      ...state,
      isLoadingJobs: false,
      totaljobsCount: data.data.count,
      pageSizeJob: data.data.page_size,
      jobList: list,
    };
  }
  return {
    ...state,
    isLoadingJobs: false,
    totaljobsCount: null,
    pageSizeJob: null,
    jobList: [],
  };
};
export const jobListRequestFailureHandler = (state, action) => {
  return {
    ...state,
    isLoadingJobs: false,
    totaljobsCount: null,
    pageSizeJob: null,
    jobList: [],
  };
};

// get Job details
export const jobDetailsRequestHandler = (state, action) => {
  return {
    ...state,
    getJobIsLoading: true,
  };
};

export const jobDetailsRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    const details = JSON.parse(JSON.stringify(data.data));
    const assigneesData = [...details.assignees];
    assigneesData.forEach((assignee, index) => {
      //check in/out
      const checkedin = details.checkinout.find(
        obj => obj.event === "checkin" && obj.user === assignee.id,
      );
      const checkedout = details.checkinout.find(
        obj => obj.event === "checkout" && obj.user === assignee.id,
      );
      const evidencesForAssignee = (details.evidences || []).filter(
        obj => obj.created_by === assignee.id,
      );

      if (checkedin) {
        assigneesData[index].checkedin = checkedin;
      }
      if (checkedout) {
        assigneesData[index].checkedout = checkedout;
      }
      // evidence(s)
      if (evidencesForAssignee && evidencesForAssignee.length) {
        assigneesData[index].evidences = evidencesForAssignee;
        // keep first evidence for backward compatibility
        assigneesData[index].evidence = evidencesForAssignee[0];
      }
      //assignee status
      if (assignee.assignee_status) {
        if (checkedin && checkedout) {
          assigneesData[index].status = "Completed";
        }
      } else {
        // Get assignee timezone or default to Asia/Dhaka
        const assigneeTimezone = assignee.timezone?.tz || "Asia/Dhaka";

        // Add 'Z' to end_time if it doesn't have timezone info (treat as UTC)
        const endTimeWithZ =
          details.end_time && !details.end_time.endsWith("Z")
            ? details.end_time + "Z"
            : details.end_time;

        // Parse as UTC and convert to assignee's timezone
        const endTimeInTimezone = endTimeWithZ
          ? moment.utc(endTimeWithZ).tz(assigneeTimezone)
          : null;

        // Get current time in assignee's timezone
        const nowInTimezone = moment.tz(assigneeTimezone);

        if (
          !checkedout &&
          endTimeInTimezone &&
          nowInTimezone.unix() < endTimeInTimezone.unix()
        ) {
          assigneesData[index].status = "To Do";
        } else {
          assigneesData[index].status = "Missed";
        }
      }
    });
    return {
      ...state,
      getJobIsLoading: false,
      jobDetails: details,
    };
  }
  return {
    ...state,
    getJobIsLoading: false,
    jobDetails: null,
  };
};

export const jobDetailsRequestFailureHandler = (state, action) => {
  createNotification(
    "error",
    "Could not fetch Job Details. Please try again!",
    3000,
  );
  return {
    ...state,
    getJobIsLoading: false,
    jobDetails: null,
  };
};

//remove assignee
export const removeJobAssigneeRequestHandler = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    JobMemberIsLoading: true,
    loadingjobId: payload.user_id,
  };
};

export const removeJobMemberRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
    userData,
  } = action;
  if (data && data.status === 204 && userData && userData.userId) {
    createNotification("success", "Assignee removed successfully", 3000);
    if (state.jobDetails) {
      const details = { ...state.jobDetails };
      const filteredList = details.assignees.filter(
        member => member.id !== userData.userId,
      );
      details.assignees = [...filteredList];
      return {
        ...state,
        jobDetails: details,
        jobAssigneeUpdate: true,
        JobMemberIsLoading: false,
        loadingjobId: null,
      };
    }
    return {
      ...state,
      JobMemberIsLoading: false,
      loadingjobId: null,
    };
  }
  return {
    ...state,
    JobMemberIsLoading: false,
    loadingjobId: null,
  };
};

export const removeJobMemberRequestFailureHandler = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification("error", "Something went wrong", 3000);
    return {
      ...state,
      JobMemberIsLoading: false,
      loadingjobId: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification("error", "Failed!! please try again", 2000);
  }
  return {
    ...state,
    JobMemberIsLoading: false,
    loadingjobId: null,
  };
};

//add assignee
export const addJobAssigneeRequestHandler = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    JobMemberIsLoading: true,
    loadingjobId: payload.user_id,
    jobAssigneeUpdate: false,
  };
};

export const addJobAssigneeRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification("success", "Assignee added successfully", 3000);
    if (state.jobDetails) {
      const details = { ...state.jobDetails };

      details.assignees = [...details.assignees, data.data.user];
      // console.log("job details from reducer", details)
      // console.log("response ", data.data)
      return {
        ...state,
        JobMemberIsLoading: false,
        loadingjobId: null,
        jobDetails: details,
        jobAssigneeUpdate: true,
      };
    }
    return {
      ...state,
      JobMemberIsLoading: false,
      loadingjobId: null,
      jobAssigneeUpdate: false,
    };
  }
  return {
    ...state,
    JobMemberIsLoading: false,
    loadingjobId: null,
    jobAssigneeUpdate: false,
  };
};

export const addJobAssigneeRequestFailureHandler = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification("error", "Something went wrong", 3000);
    return {
      ...state,
      JobMemberIsLoading: false,
      loadingjobId: null,
      jobAssigneeUpdate: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification("error", "Failed!! please try again", 2000);
  }
  return {
    ...state,
    JobMemberIsLoading: false,
    loadingjobId: null,
    jobAssigneeUpdate: false,
  };
};

export const jobShortListRequestHandler = (state, action) => {
  return {
    ...state,
    isLoadingJobs: true,
  };
};
export const jobShortListRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoadingJobs: false,
      jobShortList: data.data,
    };
  }
  return {
    ...state,
    isLoadingJobs: false,
    jobShortList: null,
  };
};
export const jobShortListRequestFailureHandler = (state, action) => {
  return {
    ...state,
    isLoadingJobs: false,
    jobShortList: null,
  };
};

export const handleExportJobReportRequest = (state, action) => {
  toast.info(
    <Message title="Please wait" body={"Preparing your download..."} />,
  );
  return {
    ...state,
    isJobExportLoading: true,
  };
};

export const handleExportJobReportSuccessRequest = (state, action) => {
  const {
    payload: { data, start_date, end_date, selectedOrganization },
  } = action;

  if (data && data.status === 200) {
    const jobs = data.data || [];

    const orgTimezone = selectedOrganization?.timezone || moment.tz.guess();
    const orgType = selectedOrganization?.type || "operation";

    const excelData = jobs.map(job => {
      const start = job.start_time
        ? moment.utc(job.start_time).tz(orgTimezone)
        : null;

      const end = job.end_time
        ? moment.utc(job.end_time).tz(orgTimezone)
        : null;

      const formattedDate = start ? start.format("DD/MM/YYYY") : "N/A";

      const timeRange =
        start && end
          ? `${start.format("h:mm a")} - ${end.format("h:mm a")}`
          : "N/A";

      let assignee = "N/A";

      if (job.assignees && job.assignees.length > 0) {
        assignee = job.assignees
          .map(a => `${a.first_name} ${a.last_name}`)
          .join(", ");
      }

      const contactInfo =
        [job.client?.email, job.client?.phone_number]
          .filter(Boolean)
          .join(" | ") || "N/A";

      return {
        [orgType === "service" ? "Job Name" : "Task Name"]: job.name
          ? job.name.charAt(0).toUpperCase() + job.name.slice(1)
          : "N/A",
        ...(orgType === "service" && {
          "Customer Name": job.client?.name || "N/A",
          "Customer Contact Info": contactInfo,
        }),
        Assignees: assignee,
        [orgType === "service" ? "Job Status" : "Task Status"]: job.status
          ? job.status.charAt(0).toUpperCase() + job.status.slice(1)
          : "N/A",
        Location: job.location || "N/A",
        Notes: job.supervisor_note || "N/A",

        "Approval Status": job.approval?.status
          ? job.approval.status.charAt(0).toUpperCase() +
            job.approval.status.slice(1)
          : "N/A",

        Date:
          formattedDate !== "N/A" && timeRange !== "N/A"
            ? `${formattedDate} — ${timeRange}`
            : "N/A",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs Report");

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], {
      type: "application/octet-stream",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `Job_Report_${start_date || ""}_to_${end_date || ""}.xlsx`;
    a.click();

    URL.revokeObjectURL(url);

    return {
      ...state,
      isJobExportLoading: false,
    };
  }

  return {
    ...state,
    isJobExportLoading: false,
  };
};

export const handleExportJobReportFailureRequest = (state, action) => {
  createNotification(
    "error",
    "Could not export Job Report. Please try again!",
    4000,
  );
  return {
    ...state,
    isJobExportLoading: false,
  };
};

//Job Status Update
export const jobUpdateRequestHandler = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const jobUpdateRequestSuccessHandler = (state, action) => {
  const {
    payload: { data, job_id, reloadJobList, details,orgType },
  } = action;
  if (data && data.status === 200) {
    const status = details?.status;
    const message =
      status === "approved"
        ? orgType === "service"
          ? "Job approved successfully"
          : "Task approved successfully"
        : status === "rejected"
        ? orgType === "service"
          ? "Job rejected successfully"
          : "Task rejected successfully"
        : orgType === "service"
        ? "Job updated successfully"
        : "Task updated successfully";
    createNotification("success", message, 2000);
    const currentList = JSON.parse(JSON.stringify(state.jobList));

    return {
      ...state,
      isLoading: false,
      reloadJobList,
      jobList: currentList.filter(job => job.id !== job_id),
      totaljobsCount: state.totaljobsCount ? state.totaljobsCount - 1 : null,
    };
  }
  return {
    ...state,
    isLoading: false,
  };
};
export const jobUpdateRequestFailureHandler = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification(
      "error",
      "Something went wrong! Please try again.",
      3000,
    );
    return {
      ...state,
      isLoading: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification("error", "Failed!! please try again", 2000);
  }
  return {
    ...state,
    isLoading: false,
  };
};

// Job Documents - functions style handlers
export const getJobDocumentRequestHandler = (state, action) => {
  return {
    ...state,
    isLoadingJobDocuments: true,
  };
};

export const getJobDocumentRequestSuccessHandler = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    isLoadingJobDocuments: false,
    jobDocuments: payload?.data?.data,
  };
};

export const getJobDocumentRequestFailureHandler = (state, action) => {
  return {
    ...state,
    isLoadingJobDocuments: false,
    jobDocuments: [],
  };
};

export const createJobDocumentRequestHandler = state => ({
  ...state,
  isLoadingJobDocuments: true,
  jobDocumentDone: false,
  error: null,
});

export const createJobDocumentRequestSuccessHandler = (state, action) => {
  const { payload } = action;
  const newDocument =
    payload && payload.data && payload.data.data ? payload.data.data : null;
  // Only show success notification if not suppressed (for CreateJobNew.jsx, suppressSuccessNotification is true)
  if (!payload || !payload.suppressSuccessNotification) {
    createNotification('success', 'Job document created successfully', 3000);
  }
  return {
    ...state,
    isLoadingJobDocuments: false,
    jobDocumentDone: true,
    jobDocuments: newDocument
      ? [...(state.jobDocuments || []), newDocument]
      : state.jobDocuments || [],
  };
};

export const createJobDocumentRequestFailureHandler = (state, action) => {
  createNotification(
    'error',
    'Failed to create job document. Please try again.',
    3000,
  );
  return {
    ...state,
    isLoadingJobDocuments: false,
    jobDocumentDone: false,
    error: action.payload || null,
  };
};

export const deleteJobDocumentRequestHandler = state => ({
  ...state,
  isLoadingJobDocuments: true,
  jobDocumentDone: false,
  error: null,
});

export const deleteJobDocumentRequestSuccessHandler = (state, action) => {
  const { document_id } = action.payload || {};
  if (!document_id) {
    return {
      ...state,
      isLoadingJobDocuments: false,
    };
  }
  createNotification('success', 'Job document deleted successfully', 3000);
  return {
    ...state,
    isLoadingJobDocuments: false,
    jobDocumentDone: true,
    jobDocuments: (state.jobDocuments || []).filter(
      item => item.id !== document_id,
    ),
  };
};

export const deleteJobDocumentRequestFailureHandler = (state, action) => {
  createNotification(
    'error',
    'Failed to delete job document. Please try again.',
    3000,
  );
  return {
    ...state,
    isLoadingJobDocuments: false,
    jobDocumentDone: false,
    error: action.payload || null,
  };
};

// Subtasks - functions style handlers
export const getSubtaskRequestHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: true,
});

export const getSubtaskRequestSuccessHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: false,
  subtasks: action.payload.data.data,
});

export const getSubtaskRequestFailureHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: false,
  subtasks: [],
});

export const createSubtaskRequestHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: true,
  subtaskCreated: false,
});

export const createSubtaskRequestSuccessHandler = (state, action) => {
  const { orgType } = action.payload || {};
  
  // Show notification based on orgType
  if (orgType === "service") {
    createNotification("success", "Line items added successfully", 3000);
  } else {
    createNotification("success", "Subtask created successfully", 3000);
  }
  
  return {
    ...state,
    isLoadingSubtasks: false,
    subtaskCreated: true,
  };
};

export const createSubtaskRequestFailureHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: false,
});

export const updateSubtaskRequestHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: true,
  subtaskUpdated: false,
});

export const updateSubtaskRequestSuccessHandler = (state, action) => {
  const { orgType } = action.payload || {};
  
  // Show notification based on orgType
  if (orgType === "service") {
    createNotification("success", "Line item updated successfully", 3000);
  } else {
    createNotification("success", "Subtask updated successfully", 3000);
  }
  
  return {
    ...state,
    isLoadingSubtasks: false,
    subtaskUpdated: true,
  };
};

export const updateSubtaskRequestFailureHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: false,
});

export const deleteSubtaskRequestHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: true,
  subtaskDeleted: false,
});

export const deleteSubtaskRequestSuccessHandler = (state, action) => {
  const { orgType } = action.payload || {};
  
  // Show notification based on orgType
  if (orgType === "service") {
    createNotification("success", "Line item deleted successfully", 3000);
  } else {
    createNotification("success", "Subtask deleted successfully", 3000);
  }
  
  return {
    ...state,
    isLoadingSubtasks: false,
    subtaskDeleted: true,
  };
};

export const deleteSubtaskRequestFailureHandler = (state, action) => ({
  ...state,
  isLoadingSubtasks: false,
});

export const resetSubtaskStatusHandler = (state, action) => ({
  ...state,
  subtaskCreated: false,
  subtaskUpdated: false,
  subtaskDeleted: false,
});

// Delete Job - functions style handlers
export const deleteJobRequestHandler = (state, action) => ({
  ...state,
  reloadJobList: null,
  jobDeleteLoading: true,
  deletingJobId: null,
});

export const deleteJobRequestSuccessHandler = (state, action) => {
  const {
    payload: { job_id, reloadJobList,orgType },
  } = action;
  createNotification("success", orgType === "operation" ? "Task deleted." : "Job deleted.", 3000);
  return {
    ...state,
    reloadJobList,
    jobDeleteLoading: false,
    deletingJobId: job_id,
    jobList: state.jobList.filter(job => job.id !== job_id),
    totaljobsCount: state.totaljobsCount ? state.totaljobsCount - 1 : null,
  };
};

export const deleteJobRequestFailureHandler = (state, action) => {
  createNotification(
    "error",
    action.orgType === "operation" ? "Failed to delete task. Please try again!" : "Failed to delete job. Please try again!",
    3000,
  );
  return {
    ...state,
    jobDeleteLoading: false,
    deletingJobId: null,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_JOBS_LIST]: jobListRequestHandler,
  [GET_JOBS_LIST_SUCCESS]: jobListRequestSuccessHandler,
  [GET_JOBS_LIST_FAILURE]: jobListRequestFailureHandler,

  [GET_JOBS_SHORT_LIST]: jobShortListRequestHandler,
  [GET_JOBS_SHORT_LIST_FAILURE]: jobShortListRequestFailureHandler,
  [GET_JOBS_SHORT_LIST_SUCCESS]: jobShortListRequestSuccessHandler,

  [GET_JOB_DETAILS]: jobDetailsRequestHandler,
  [GET_JOB_DETAILS_SUCCESS]: jobDetailsRequestSuccessHandler,
  [GET_JOB_DETAILS_FAILURE]: jobDetailsRequestFailureHandler,

  [JOB_ASSIGNEE_REMOVE]: removeJobAssigneeRequestHandler,
  [JOB_ASSIGNEE_REMOVE_SUCCESS]: removeJobMemberRequestSuccessHandler,
  [JOB_ASSIGNEE_REMOVE_FAILURE]: removeJobMemberRequestFailureHandler,

  [JOB_ASSIGNEE_ADD]: addJobAssigneeRequestHandler,
  [JOB_ASSIGNEE_ADD_SUCCESS]: addJobAssigneeRequestSuccessHandler,
  [JOB_ASSIGNEE_ADD_FAILURE]: addJobAssigneeRequestFailureHandler,
  [EXPORT_JOB_REPORT]: handleExportJobReportRequest,
  [EXPORT_JOB_REPORT_SUCCESS]: handleExportJobReportSuccessRequest,
  [EXPORT_JOB_REPORT_FAILURE]: handleExportJobReportFailureRequest,

  [GET_SUBTASKS]: getSubtaskRequestHandler,
  [GET_SUBTASKS_SUCCESS]: getSubtaskRequestSuccessHandler,
  [GET_SUBTASKS_FAILURE]: getSubtaskRequestFailureHandler,

  [CREATE_SUBTASK]: createSubtaskRequestHandler,
  [CREATE_SUBTASK_SUCCESS]: createSubtaskRequestSuccessHandler,
  [CREATE_SUBTASK_FAILURE]: createSubtaskRequestFailureHandler,

  [UPDATE_SUBTASK]: updateSubtaskRequestHandler,
  [UPDATE_SUBTASK_SUCCESS]: updateSubtaskRequestSuccessHandler,
  [UPDATE_SUBTASK_FAILURE]: updateSubtaskRequestFailureHandler,

  [DELETE_SUBTASK]: deleteSubtaskRequestHandler,
  [DELETE_SUBTASK_SUCCESS]: deleteSubtaskRequestSuccessHandler,
  [DELETE_SUBTASK_FAILURE]: deleteSubtaskRequestFailureHandler,

  [RESET_SUBTASK_STATUS]: resetSubtaskStatusHandler,

  [DELETE_JOB]: deleteJobRequestHandler,
  [DELETE_JOB_SUCCESS]: deleteJobRequestSuccessHandler,
  [DELETE_JOB_FAILURE]: deleteJobRequestFailureHandler,
  [UPDATE_JOB_STATUS]: jobUpdateRequestHandler,
  [UPDATE_JOB_STATUS_SUCCESS]: jobUpdateRequestSuccessHandler,
  [UPDATE_JOB_STATUS_FAILURE]: jobUpdateRequestFailureHandler,

  // Job Documents
  [GET_JOB_DOCUMENTS_LIST]: getJobDocumentRequestHandler,
  [GET_JOB_DOCUMENTS_LIST_SUCCESS]: getJobDocumentRequestSuccessHandler,
  [GET_JOB_DOCUMENTS_LIST_FAILURE]: getJobDocumentRequestFailureHandler,

  [CREATE_JOB_DOCUMENT]: createJobDocumentRequestHandler,
  [CREATE_JOB_DOCUMENT_SUCCESS]: createJobDocumentRequestSuccessHandler,
  [CREATE_JOB_DOCUMENT_FAILURE]: createJobDocumentRequestFailureHandler,

  [DELETE_JOB_DOCUMENT]: deleteJobDocumentRequestHandler,
  [DELETE_JOB_DOCUMENT_SUCCESS]: deleteJobDocumentRequestSuccessHandler,
  [DELETE_JOB_DOCUMENT_FAILURE]: deleteJobDocumentRequestFailureHandler,
};

// default initial state
const initialState = {
  isLoadingJobs: false,
  totaljobsCount: null,
  pageSizeJob: null,
  jobList: [],
  jobShortList: null,

  //Job details
  getJobIsLoading: false,
  jobDetails: null,

  JobMemberIsLoading: false,
  loadingjobId: null,

  jobAssigneeUpdate: false,

  jobDeleteLoading: false,
  deletingJobId: null,
  reloadJobList: null,
  //job status
  isLoading: false,
  isJobExportLoading: false,

  // subtasks
  subtasks: [],
  isLoadingSubtasks: false,
  subtaskCreated: false,
  subtaskUpdated: false,
  subtaskDeleted: false,
};

export default function jobsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
